module.exports = __webpack_public_path__ + "static/media/shakehands-removebg.0679670b.png";